import { render } from "./RechargeResult.vue?vue&type=template&id=067e8b6f&scoped=true"
import script from "./RechargeResult.vue?vue&type=script&lang=js"
export * from "./RechargeResult.vue?vue&type=script&lang=js"

import "./RechargeResult.vue?vue&type=style&index=0&id=067e8b6f&scoped=true&lang=css"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067e8b6f"]])

export default __exports__